<template>
  <div>
    <el-dialog :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      custom-class="dialog"
      :width="isPhone ? '90%' : '540px'"
      center>
      <div class="title">{{ title }}<span class="en-title">{{ enTitle }}</span></div>
      <div class="line"></div>
      <div class="msg">
        {{ msg }}
      </div>
      <div class="en-msg">
        {{ enMsg }}
      </div>
      <div class="dialog-footer">
        <div class="cancel btn" v-if="cancel" @click="cancelFn">{{ cancel }}<span class="en-btn">{{ enCancel }}</span></div>
        <div class="confirm btn" v-if="confirm" @click="confirmFn">{{ confirm }}<span class="en-btn">{{ enConfirm }}</span></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    enTitle: {
      type: String,
      default: 'Tips'
    },
    msg: {
      type: String
    },
    enMsg: {
      type: String
    },
    confirm: {
      type: String
    },
    enConfirm: {
      type: String
    },
    cancel: {
      type: String
    },
    enCancel: {
      type: String
    },
    isPhone: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cancelFn () {
      this.$emit('cancel')
    },
    confirmFn () {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .dialog{
  border-radius: 30px;
  padding: 10px 30px 30px;
}
.title{
  text-align: center;
  font-family: regular;
  font-size: 28px;
  color: #000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.en-title{
  text-align: center;
  color: #A48C4E;
  font-size: 18px;
  font-family: normal;
  margin-left: 10px;
}
.line{
  width: 100px;
  height: 2px;
  background-color: #b81c25;
  margin: 10px auto 20px;
  display: block;
}
.msg{
  color: #000;
  margin-bottom: 14px;
  font-size: 16px;
  text-align: center;
}
.en-msg{
  color: #A48C4E;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
}
.dialog-footer{
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.btn{
  // width: 200px;
  flex: 1;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  border: 1px solid #b81c25;
  font-size: 16px;
  cursor: pointer;
  margin: 20px 10px 0;
}
.en-btn{
  font-size: 14px;
  margin-left: 10px
}
.confirm{
  background-color: #b81c25;
  color: #fff;
}
.cancel{
  color: #b81c25;
}
</style>
